import React, { useState } from 'react';
import shopIcon from '../assets/shop_icon.png';
import ShopModal from './ShopModal';

export default function ShopButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 62,
          left: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={shopIcon} alt="Leaderboard" style={{ width: 70, height: 70 }} />
      </button>
      <ShopModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
